<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-medium.mt-2 {{ $t('delete_confirmation', { text: 'inventory list' }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: 'inventory list' }) }}
      v-sheet.pa-4.my-3.neutral200.rounded-lg
        .text-sm Name: 
          span.font-semibold {{ parentData.name }}
        .text-sm Order frequency: 
          span.font-semibold {{ parentData.order_freq }}
        .text-sm Remarks: 
          span.font-semibold {{ parentData.remarks }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text :disabled="isLoading" @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    parentData: {
      type: Object,
      required: true
    },
    overrideCompanySlug: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    companySlugToUse () {
      return this.overrideCompanySlug || this.company.slug
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    async handleConfirm () {
      try {
        this.isLoading = true
        const endpoint = `/clinics/${this.companySlugToUse}/inventory_lists/${this.parentData.id}`
        const resp = await this.axios.delete(endpoint)
        this.updateActivityLog(endpoint, null, resp, 'DELETE', this.parentData.id)
        this.$emit('deleted')
        this.showMessage(['success', 'Inventory list deleted successfully'])
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: 'Delete inventory list',
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>